import { rows, Filters, List } from "colbi_web_ui/lib/components";
import { parseFilter } from "colbi_web_ui/lib/utils";
import theme from "colbi_web_ui/lib/style/_theme.json";
import App from "../controllers/App/App";

const queries = (args = {}) => {
    return [
        {
            resource: args.section,
            args: {
                projectId: args.projectId,
                sort: args.sort
                    ? { type: "[SortInput!]", value: parseFilter(args.sort) }
                    : undefined,
                filter: args.filter
                    ? { type: "[FilterInput!]", value: parseFilter(args.filter) }
                    : undefined,
                locale: args.locale,
                page: parseInt(args.page, 10),
            },
            body: `__typename, items{...${args.section}}, total, hasMore,filters(projectId:$projectId){ prop, name, type, list, disableOperators }`,
            downloadable: true,
        },
        {
            resource: "project_modules",
            args: {
                projectId: args.projectId,
            },
            body: "modules",
        },
    ].filter((r) => !!r.resource);
};

const customReportConfiguration = (path, navigation) => ({
    path,
    navigation,
    component: App,
    exact: false,
    queries,
    components: [
        {
            component: Filters,
            props: {
                filter: "param(filter)",
                availableFilters: "query(0).filters",
                stickyTop: parseInt(theme.layout.$headerHeight, 10),
                anchor: "results",
            },
        },
        {
            component: List,
            modifiers: ["--root-margin-top-small", "--row-style-alternate"],
            props: {
                id: "results",
                card: rows.EntityCard,
                checkbox: true,
                items: "query(0).list",
                header: "query(0).header",
                footer: "query(0).footer",
                metadata: "query(0).metadata",
                page: "param(page)",
                status: "status(0)",
                pageSize: "param(pageSize)",
                pageDefault: 10,
                filter: "param(filter)",
                availableFilters: "query(0).filters",
                sort: "param(sort)",
                wrapper: "wrapper",
                onClickPushModal: {
                    title: "Update Report Configuration",
                    view: "CustomReportConfiguration",
                },
            },
        },
    ],
});

export default customReportConfiguration;
